'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import { useBoolean } from 'usehooks-ts';

import GTM, { buildGTMEvent } from '@/consts/gtm';
import {
  MobileBold,
  MobileDescription,
  MobileWrapper,
  Title,
  TitleWrapper,
} from '@/features/MainLayout';

import HelpPill from '../_components/HelpPill';
import HelpAnimatePersona from './_components/layout/HelpAnimatePersona';
const ConditionalDescription = dynamic(
  () => import('./_components/layout/conditionalDescription'),
  {
    ssr: false,
  },
);

const CustomRepliesToneLayout = ({ children }) => {
  const { value, setTrue, setFalse } = useBoolean();

  return (
    <>
      <div className={'flex justify-between items-center w-full'}>
        <TitleWrapper className={'hidden 2xl:block px-3.5 md:px-0 pb-0 gap-0 md:gap-2'}>
          <Title className={'flex  gap-1 items-center pb-0'}>
            <div className={'flex items-center gap-1'}>AI 말투 설정</div>
          </Title>

          <Suspense fallback={<></>}>
            <ConditionalDescription />
          </Suspense>
        </TitleWrapper>

        <MobileWrapper className={'hidden md:block'}>
          <MobileDescription>
            댓글 초안을 생성할 <MobileBold>사장님만의 말투</MobileBold>를 선택해보세요
          </MobileDescription>
        </MobileWrapper>

        <HelpPill onClick={setTrue} data-gtm-id={buildGTMEvent(GTM.AI_TONE_TOOLTIP_CLICK)}>
          말투를 설정하면 초안에 어떻게 보여지나요?
        </HelpPill>
      </div>
      <HelpAnimatePersona value={value} setFalse={setFalse} />
      <section className="pb-[80px] md:pb-0">{children}</section>
    </>
  );
};

export default CustomRepliesToneLayout;
